module.exports = new __parcel__URL__("b2b-icon-praxis.b3e6be8f.png").toString();